// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import colors from '../../../../styled-components/palette';
import { MRMonopoly } from '../../assets/img';
import { useMPViewContext } from '../../contexts/MPViewContext';
import MPPrimaryButton from '../MPPrimaryButton';

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: row;
  z-index: 10;
  height: ${({ $height }) => `${$height}px`};
`;

const MisterMonop = styled.img`
  position: absolute;
  z-index: 2;
  width: 12.1em;
  bottom: 1.5em;
  left: 0em;
`;

const MessageWrapper = styled.div`
  background-color: #fff;
  position: relative;
  border-radius: 15px;
  margin: 0.6em;
  margin-top: auto;
`;

const MessageContent = styled.div`
  padding: 0.8em;
  padding-right: 2em;
  padding-left: 12em;
`;

const Title = styled.div`
  font-family: 'KabelHasbro';
  font-weight: 600;
  color: ${colors.bluegrey950};
  font-size: 1.4em;
  line-height: 1em;
`;

const Content = styled.div`
  color: #3d455c;
  margin-top: 0.6em;
  font-size: 1em;
  line-height: 1.1em;
`;

const StyledMPPrimaryButton = styled(MPPrimaryButton)`
  display: inline-block;
  margin-top: 0.6em;
  position: relative;
  z-index: 2;
`;

type MPWelcomeProps = {
  onClick: () => void;
};

const MPWelcome = ({ onClick }: MPWelcomeProps) => {
  const { height } = useMPViewContext();
  return (
    <Wrapper $height={height}>
      <MisterMonop src={MRMonopoly} />
      <MessageWrapper>
        <MessageContent>
          <Title>{__('!noun:Welcome')}</Title>
          <Content>{__('Gather properties, complete colour collections and win lots of Freebets!')}</Content>
          <StyledMPPrimaryButton onClick={onClick}>{__('Ok')}</StyledMPPrimaryButton>
        </MessageContent>
      </MessageWrapper>
    </Wrapper>
  );
};

export default MPWelcome;
